module.exports = "/_next/static/images/8e5200d22f89013f860042c2c9d0951e-nubanker-xpeer@1x.jpg.webp";